import { useRequest } from 'ahooks';
import { values, pick, isNil } from 'lodash-es';
import {
  getIndustryRank,
  getRecoverRank,
  IndustryRankRequest,
  RecoverRankRequest,
} from 'services/api/dashboard';
import { errorToasterWithServerMsg } from 'utils/errorToaster';

type PartialOmitExtend<T extends E, E> = Partial<Pick<T, keyof Omit<T, keyof E>> & E>;
type IndustryRankParams = PartialOmitExtend<IndustryRankRequest, Dashboard.BasicParams>;
type RecoverRankParams = PartialOmitExtend<RecoverRankRequest, Dashboard.BasicParams>;

function useIndustryRank(params: IndustryRankParams) {
  return useRequest(
    async () => {
      if (values(pick(params, ['startTime', 'endTime', 'performanceName'])).some((v) => isNil(v))) {
        return null;
      }
      const data = await getIndustryRank(params);
      return data;
    },
    {
      cacheKey: '@@useIndustryRank',
      manual: true,
      onError(err) {
        errorToasterWithServerMsg(err);
      },
    },
  );
}

function useRecoverRank(params: RecoverRankParams) {
  return useRequest(
    async () => {
      if (
        values(pick(params, ['startTime', 'endTime', 'cancelType', 'reason', 'isCod'])).some((v) =>
          isNil(v),
        )
      ) {
        return null;
      }
      const data = await getRecoverRank(params);
      return data;
    },
    {
      cacheKey: '@@useRecoverRank',
      manual: true,
      onError(err) {
        errorToasterWithServerMsg(err);
      },
    },
  );
}

export { useIndustryRank, useRecoverRank };
